import Auth from './Auth'
import routerGuard from './../common/routerBeforeGuard'

import URLS from './urls'
import { frontendcommonCss, logo, logoSmall, logoColor, logoColorSmall, colors } from './frontendcommon'
import AxiosPlugin from './AxiosPlugin'
import LoadingSpinner from './LoadingSpinner'
import App from './App'

const sidebarLoading = false
const SidebarBottom = undefined
const enableMobileLayout = false
const sentryDns = 'https://6134b2f9b058457185e5c874c3703b55@sentry.farmapremium.es/9'

export {
  Auth,
  routerGuard,
  frontendcommonCss,
  colors,
  logo,
  logoSmall,
  logoColor,
  logoColorSmall,
  enableMobileLayout,
  sidebarLoading,
  SidebarBottom,
  App,
  URLS,
  AxiosPlugin,
  sentryDns,
  LoadingSpinner
}
